export interface GoogleSheetDatasetRunPayload {
  completed_at: string | null;
  created_at: string;
  is_latest_report_run: boolean;
  is_latesets_successful_report_run: boolean;
  purge_completed_at: string | null;
  purge_started_at: string | null;
  pusher_channel_name: string;
  report_has_failures_since_last_success: boolean;
  state: string;
  token: string;
  updated_at: string;
  _forms: any;
  _links: any;
}

export interface GoogleSheetRunPusherSuccessPayload {
  token: string;
  state: string;
  dataset_report_token: string;
  _links: {
    web_edit_dataset: {
      href: string;
    };
    import_in_new_report: {
      href: string;
    };
  };
}

export enum GoogleSheetRunEvents {
  GoogleSheetEnqueued = 'run_enqueued',
  GoogleSheetSuccess = 'run_succeeded',
  GoogleSheetFailed = 'run_failed',
}
